<a
	class="vertical-item"
	[class.not-implemented]="item.implemented !== true"
	[class.disabled]="item.disabled === true"
	[class.active]="isActive()"
	[href]="item.href"
	[attr.aria-disabled]="item.disabled === true"
	(click)="onItemClick($event)"
>
	{{ item.label }}
</a>
